import { Box, Stack, Text } from "@chakra-ui/react";
import _ from 'lodash';
import moment from"moment"
import { useEffect, useRef, useState } from "react";
import ChatSkeleton from "../../components/ChatSkeleton";
import MessageBox from "./MessageBox";
import { ChatFeed } from "./ChatFeed";

function ChatArea({
  chats,
  userId,
  user,
  accountType,
  selectedChat,
  groupMessages,
  handleSendMsg,
  handleSendFile,
  receiverCurrentChat,
  currentGroupChat,
  incomingLastMessage,
  setImgPreview,
  imgPreview,
  setIsServerImageLoaded,
  isServerImageLoaded,
  setProgressBar,
  progressBar,
}) {
  const ref = useRef(null);

  const [parentWidth, setParentWidth] = useState(0);
  const [values, setValues] = useState([]);
  const [loading, setLoading] = useState(true);

  //console.log('cjats: ', chats);
  
  // if(groupMessages){
  //   setLoading(false)
  // }

  

  // Define a function to group chat messages by date
  const groupChatMessagesByDate = (messages) => {
    const groupedMessages = {};
    messages.forEach((message) => {
      //console.log("message-->", message);
      const messageDate = new Date(message.timestamp); // Replace 'timestamp' with your message date property
      const messageDateStr = messageDate.toDateString(); // Grouping by date string
      if (!groupedMessages[messageDateStr]) {
        groupedMessages[messageDateStr] = [];
      }
      groupedMessages[messageDateStr].push(message);
    });
    return groupedMessages;

  };

  useEffect(() => {
    setParentWidth(ref.current.offsetWidth);


    const resize = () => {
      setParentWidth(ref?.current?.offsetWidth);
      console.log('ref',ref.current?.offsetWidth)
    };

    const resizeObserver = new ResizeObserver((entries) => {
      resize();
    });

    resizeObserver.observe(document.getElementsByClassName("chat-area")[0]);
  }, []);

  // Group chat messages by date
  const groupedMessages = groupChatMessagesByDate(groupMessages);
const groupProp = _.property('created_at');

let determineGroup = value => {
  // remove '2017-11-15' to actually use current date 
  const now = moment().startOf('day');
console.log('now',now)

  if (value.isSame(now, 'day')) {
    return 'today';
  }
  if (value.isAfter(now.clone().subtract(7, 'days').startOf('day'))) {
    return 'this week';
  }
  if (value.isSame(now, 'month')) {
    return 'this month';
  }
  return value.format('DD/MM/YY');
};

let grouped = _
  .chain(groupMessages)
  .groupBy(datum => determineGroup(moment(groupProp(datum))))
  .value();
   
   function renderObject(){
        return Object.entries(grouped).map(([key, value], i) => {
            return (
                <div key={key}>
                  <Box ml={'50%'} borderRadius="lg">
            <Text
              whiteSpace="pre-wrap"
              p="10px"
              fontSize={["1.4em", ".8em", ".8em", ".8em"]}
              maxW="300px"
              color= "#7B8793"            
            >
              {key}
            </Text>
 </Box>
                  {value.map((val,index)=>{
                   return (<>         
<ChatFeed key={index} chat={val} userId={userId} 
          currentGroupChat={currentGroupChat} receiverCurrentChat={receiverCurrentChat} 
          incomingLastMessage={incomingLastMessage}
          setIsServerImageLoaded={setIsServerImageLoaded}
          isServerImageLoaded={isServerImageLoaded} 
          />
</>)
                  })}
                   
                   
                </div>
            )
        })
    }

  return (
    <Stack
      className="chat-area scroll-container"
      position={"relative"}
      p="10px"
      height={[window.innerHeight - 300, window.innerHeight - 100]}
      maxH={["unset", window.innerHeight - 250]}
      overflowY={"scroll"}
      ref={ref}
      bg="transparent !important"
    >
      {groupMessages?.length < 0 ? (
        <Text>Select Group to continue</Text>
      ) : (
        renderObject()
      )}
  
      <Box mt="50px !important" />
      <MessageBox
        user={user}
        selectedChat={selectedChat}
        width={parentWidth}
        accountType={accountType}
        groupChatId={chats?.group_chat_id}
        handleSendMsg={handleSendMsg}
        handleSendFile={handleSendFile}
        setImgPreview={setImgPreview}
        setIsServerImageLoaded={setIsServerImageLoaded}
        isServerImageLoaded={isServerImageLoaded}
        setProgressBar={setProgressBar}
        progressBar={progressBar}
      />
    </Stack>
  );
}

export default ChatArea;
